module.exports = __webpack_public_path__ + "static/assets/50404d1bb8ac41093632a346250445c9.svg";